import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=bfdeec38&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
import style0 from "./UserList.vue?vue&type=style&index=0&id=bfdeec38&prod&lang=scss"
import style1 from "./UserList.vue?vue&type=style&index=1&id=bfdeec38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdeec38",
  null
  
)

export default component.exports